import { Card, Box, Typography, CircularProgress, Tooltip } from "@mui/material"
import {
    WiDaySunny,
    WiNightClear,
    WiDayCloudy,
    WiNightAltCloudy,
    WiCloud,
    WiCloudy,
    WiDayShowers,
    WiNightAltShowers,
    WiDayRain,
    WiNightAltRain,
    WiThunderstorm,
    WiSnow,
    WiFog,
} from 'react-icons/wi'
import React from "react"

const WeatherForecast = ({ weatherData, isLoading, error }) => {

    const getWeatherIcon = (iconCode, size = 24) => {
        const color = "#0782cc";
        if (iconCode === '01d') return <WiDaySunny size={size} color={color} />;
        if (iconCode === '01n') return <WiNightClear size={size} color={color} />;
        if (iconCode === '02d') return <WiDayCloudy size={size} color={color} />;
        if (iconCode === '02n') return <WiNightAltCloudy size={size} color={color} />;
        if (iconCode === '03d' || iconCode === '03n') return <WiCloud size={size} color={color} />;
        if (iconCode === '04d' || iconCode === '04n') return <WiCloudy size={size} color={color} />;
        if (iconCode === '09d') return <WiDayShowers size={size} color={color} />;
        if (iconCode === '09n') return <WiNightAltShowers size={size} color={color} />;
        if (iconCode === '10d') return <WiDayRain size={size} color={color} />;
        if (iconCode === '10n') return <WiNightAltRain size={size} color={color} />;
        if (iconCode === '11d' || iconCode === '11n') return <WiThunderstorm size={size} color={color} />;
        if (iconCode === '13d' || iconCode === '13n') return <WiSnow size={size} color={color} />;
        if (iconCode === '50d' || iconCode === '50n') return <WiFog size={size} color={color} />;
        return <WiDaySunny size={size} color={color} />;
    };

    if (isLoading) {
        return (
            <Card sx={{ padding: 5, marginY: 5, textAlign: 'center' }}>
                <CircularProgress />
            </Card>
        );
    }

    if (error) {
        return (
            <Card sx={{ padding: 3, textAlign: 'center' }}>
                <Typography color="error">Weather currently unavailable</Typography>
            </Card>
        );
    }

    if (!weatherData || !weatherData.current) {
        return null;
    }

    return (
        <Card sx={{
            height: { xs: '140px', sm: '120px', md: '150px' },
            p: { xs: 0.5, md: 2.25 },
            mb: 2.5,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            overflowX: { xs: 'scroll', sm: 'scroll', md: 'hidden' },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: 1
        }}>

            <Box id="today-container" sx={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', ml: 2, pr: { xs: 4 } }}>

                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                    <Tooltip title={weatherData.current.description} arrow placement="top-start">
                        <Box sx={{ display: 'inline-flex', alignContent: 'center', m: 0, cursor: 'help' }}>
                            {getWeatherIcon(weatherData.current.icon, 48)}
                        </Box>
                    </Tooltip>
                    <p style={{ fontWeight: 'bold', fontSize: '32px', margin: 0 }}>{Math.round(weatherData.current.temp)}°</p>

                </Box>

                <p style={{ fontSize: '16px', color: 'black', margin: 0 }}>{weatherData.location}</p>

            </Box>

            <Box id="future-forecast-container" sx={{ maxWidth: '50vw', display: 'flex', flexDirection: 'row', gap: { xs: 2.5, md: 5 } }}>
                {weatherData.forecast.map((d) => {
                    return (
                        <Box sx={{ textAlign: 'center', p: 1, maxWidth: '50vw', '&:last-child': { mr: 2 } }} key={d.dayOfWeek} index={d.dayOfWeek}>
                            <p style={{ color: 'gray', margin: 0 }}>{d.dayOfWeek.slice(0, 3)}</p>
                            <div style={{ margin: 0 }}>{getWeatherIcon(d.icon)}</div>
                            <p style={{ margin: 0 }}>{Math.round(d.high)}°</p>
                            <p style={{ color: 'gray', margin: 0 }}>{Math.round(d.low)}°</p>
                        </Box>
                    )
                })}
                <Box sx={{ minWidth: 1.25, flexShrink: 0 }} />

            </Box>
        </Card>
    )
}

export default WeatherForecast;